module.exports = __webpack_public_path__ + "media/07_masyono_sono.2b9aacc7.mp3";